import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: ['Product', 'Category'],
  endpoints: (builder) => ({
    getAllProduct: builder.query({
      query: () => 'product/getAllproduct/',
      providesTags: ['Product'],
    }),
    detailedProduct: builder.query({
      query: (id) => `product/getDetailedProduct/${id}`,
      providesTags: ['Product'],
    }),
    // Creates the Product and its first variant (sku/price/stock_quantity)
    // in one call.
    postProduct: builder.mutation({
      query: (data) => ({
        url: 'product/add/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    updateProduct: builder.mutation({
      query: ({ data, id }) => ({
        url: `product/update/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `product/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Product'],
    }),
    updateVariant: builder.mutation({
      query: ({ data, id }) => ({
        url: `product/variant/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    recordStockMovement: builder.mutation({
      query: ({ variantId, ...data }) => ({
        url: `product/variant/${variantId}/stock/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    uploadProductImage: builder.mutation({
      query: ({ productId, formData }) => ({
        url: `product/${productId}/images/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Product'],
    }),
    getAllCategories: builder.query({
      query: () => 'product/categories/',
      providesTags: ['Category'],
    }),
    createCategory: builder.mutation({
      query: (data) => ({
        url: 'product/categories/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),
    getCategory: builder.query({
      query: (id) => `product/categories/${id}`,
      providesTags: ['Category'],
    }),
    updateCategory: builder.mutation({
      query: ({ data, id }) => ({
        url: `product/categories/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `product/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Category'],
    }),
    getLowStockVariants: builder.query({
      query: () => 'product/variants/low-stock/',
      providesTags: ['Product'],
    }),
  }),
})

export const {
  useGetAllProductQuery,
  useDetailedProductQuery,
  usePostProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useUpdateVariantMutation,
  useRecordStockMovementMutation,
  useUploadProductImageMutation,
  useGetAllCategoriesQuery,
  useCreateCategoryMutation,
  useGetCategoryQuery,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetLowStockVariantsQuery,
} = productApi
